import { Box, FormControlLabel, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CustomFormControlLabel = styled(FormControlLabel)({
  '& .MuiTypography-root': {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '100%',
    color: 'rgba(0, 0, 0, 1)',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
});

export const TooltipContainer = styled(Box)({
  padding: '8px 10px',
  width: 240,
});

export const HeadingText = styled(Typography)({
  fontSize: 14,
  fontWeight: 700,
  lineHeight: '28px',
  letterSpacing: '0.15px',
  color: '#000000',
});
